<template>
  <v-dialog v-model="dialog" persistent max-width="440" content-class="auth-dialog">
    <v-card class="auth-card" elevation="12">
      <Overlay />

      <div class="auth-card__header">
        <div class="auth-card__icon">
          <v-icon color="white" size="30">mdi-account-outline</v-icon>
        </div>
        <h1 class="auth-card__title">Connexion</h1>
        <p class="auth-card__subtitle mb-0">Accédez à votre espace de gestion</p>
      </div>

      <v-card-text class="auth-card__content">
        <v-form ref="loginForm" v-model="valid" lazy-validation @submit.prevent="validate">
          <v-text-field
            v-model="loginEmail"
            :rules="loginEmailRules"
            label="Adresse e-mail"
            prepend-inner-icon="mdi-email-outline"
            autocomplete="email"
            outlined
            required
          />

          <v-text-field
            v-model="loginPassword"
            :rules="[rules.required, rules.min]"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            label="Mot de passe"
            prepend-inner-icon="mdi-lock-outline"
            autocomplete="current-password"
            outlined
            required
            @click:append="showPassword = !showPassword"
          />

          <v-alert v-if="messageError" dense text type="error" class="mb-3">
            {{ messageError }}
          </v-alert>

          <div class="d-flex justify-end mb-4">
            <v-btn text small color="primary" class="auth-card__link" @click="recover">
              Mot de passe oublié ?
            </v-btn>
          </div>

          <v-btn type="submit" :disabled="!valid" color="primary" depressed large block>
            <v-icon left>mdi-login</v-icon>
            Se connecter
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Overlay from '../outils/overlay'

export default {
  name: 'LoginComponent',
  components: { Overlay },
  data() {
    return {
      dialog: true,
      valid: true,
      messageError: '',
      showPassword: false,
      loginPassword: '',
      loginEmail: '',
      loginEmailRules: [
        value => !!value || 'E-mail requis',
        value => /.+@.+\..+/.test(value) || 'Saisissez une adresse e-mail valide'
      ],
      rules: {
        required: value => !!value || 'Mot de passe requis',
        min: value => (value && value.length >= 8) || 'Minimum 8 caractères'
      }
    }
  },
  watch: {
    '$store.getters.isAuth': {
      handler(value) {
        if(value) {
          // checkConnectionAndEnter attend le chargement des pages dynamiques
          // avant de rediriger. Une navigation ici monterait une page trop tôt.
          this.dialog = false
        }
      }
    }
  },
  methods: {
    validate() {
      if(!this.$refs.loginForm.validate()) return

      this.messageError = ''
      this.$store.dispatch('getoverlay', true)
      this.$store.dispatch('textOverlay', 'Connexion en cours...')
      this.API({
        type: 'post',
        url: '/auth/login',
        params: { email: this.loginEmail, password: this.loginPassword }
      }).then(response => {
        if(response.data.success) {
          localStorage.setItem('tokenMinu', response.data.token)
          localStorage.setItem('firstConnect', true)
          this.$root.checkConnectionAndEnter(this.$route.query.redirect)
        } else {
          this.messageError = response.data.message
          this.$store.dispatch('getoverlay', false)
        }
      })
    },
    recover() {
      this.$router.push({ name: 'forgotp' })
    }
  }
}
</script>

<style scoped>
::v-deep .auth-dialog {
  margin: 12px;
  border-radius: 16px;
}
.auth-card {
  overflow: hidden;
  border-radius: 16px !important;
}
.auth-card__header {
  padding: 30px 28px 28px;
  color: #fff;
  text-align: center;
  background: linear-gradient(135deg, #283593 0%, #1565c0 100%);
}
.auth-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-bottom: 14px;
  border: 1px solid rgba(255, 255, 255, .32);
  border-radius: 16px;
  background: rgba(255, 255, 255, .14);
}
.auth-card__title {
  margin: 0 0 4px;
  font-size: 1.55rem;
  font-weight: 600;
  line-height: 1.3;
}
.auth-card__subtitle {
  color: rgba(255, 255, 255, .82);
  font-size: .92rem;
}
.auth-card__content { padding: 30px 32px 32px !important; }
.auth-card__link { text-transform: none; letter-spacing: normal; }
@media (max-width: 600px) {
  .auth-card__header { padding: 24px 20px 22px; }
  .auth-card__content { padding: 24px 20px 22px !important; }
}
</style>
